import { RunningIcon } from "../../assets";
import { COLORS } from "../../constants";
import styles from "./styles.module.scss";

type ActivityIconProps = {
  isGrayed?: boolean;
};

const ActivityIcon: React.FC<ActivityIconProps> = ({ isGrayed }) => {
  return (
    <div
      className={styles.wrapper}
      style={{
        backgroundColor: isGrayed
          ? COLORS.mediumGray
          : COLORS.springGreenOpacity20,
      }}
    >
      <RunningIcon
        style={{ fill: isGrayed ? COLORS.darkGray : COLORS.springGreen }}
      />
    </div>
  );
};

export default ActivityIcon;
